"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactI18next = require("react-i18next");
var _InnerPopupWrapper = _interopRequireDefault(require("../InnerPopupWrapper"));
var _planDetailsSlice = require("../../redux/planDetailsSlice");
var _store = require("../../redux/store");
var _offersSlice = require("../../redux/offersSlice");
var _popupSlice = require("../../redux/popupSlice");
var _unsubscribeSlice = require("../../redux/unsubscribeSlice");
var _retentionActionsSlice = require("../../redux/retentionActionsSlice");
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _components = require("./components");
var _Unsubscribe = _interopRequireDefault(require("./Unsubscribe.enum"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Unsubscribe = _ref => {
  let {
    customCancellationReasons,
    skipAvailableDowngradesStep,
    skipAvailableFreeExtensionStep
  } = _ref;
  const INITIAL_STEPS_ARRAY = [_Unsubscribe.default.SURVEY, _Unsubscribe.default.CONFIRMATION];
  const [downgradesList, setDowngradesList] = (0, _react.useState)([]);
  const [checkedReason, setCheckedReason] = (0, _react.useState)('');
  const [isFreeExtensionSecondStep, setIsFreeExtensionSecondStep] = (0, _react.useState)(false);
  const [steps, setSteps] = (0, _react.useState)([]);
  const {
    pauseOffersIDs
  } = (0, _store.useAppSelector)(_offersSlice.selectOffers);
  const {
    data: switchSettings
  } = (0, _store.useAppSelector)(_planDetailsSlice.selectSwitchSettings);
  const {
    data: switchDetails
  } = (0, _store.useAppSelector)(_planDetailsSlice.selectSwitchDetails);
  const offerDetails = (0, _store.useAppSelector)(_popupSlice.selectOfferData);
  const {
    error: isError
  } = (0, _store.useAppSelector)(_unsubscribeSlice.selectUnsubscribe);
  const {
    retentionActions
  } = (0, _store.useAppSelector)(_retentionActionsSlice.selectRetentionActions);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const dispatch = (0, _store.useAppDispatch)();
  const getDowngrades = () => {
    if (Object.keys(switchSettings).length && offerDetails) {
      const offerSwitchSettings = switchSettings[offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.offerId];
      return [...offerSwitchSettings.available].filter(offer => offer.switchDirection === 'downgrade').sort((aOffer, bOffer) => bOffer.price - aOffer.price);
    }
    return [];
  };
  const scheduledSwitch = () => {
    if (offerDetails !== null && offerDetails !== void 0 && offerDetails.pendingSwitchId) {
      return switchDetails[offerDetails.pendingSwitchId];
    }
    return false;
  };
  const downgrades = getDowngrades();
  const shouldShowDowngradeScreen = () => {
    if (skipAvailableDowngradesStep) return false;
    const scheduled = scheduledSwitch();
    if (scheduled && scheduled.direction === 'downgrade' && offerDetails !== null && offerDetails !== void 0 && offerDetails.pendingSwitchId) return false;
    if (!(offerDetails !== null && offerDetails !== void 0 && offerDetails.inTrial) && downgrades.length) {
      const downgradesFiltered = downgrades.filter(_ref2 => {
        let {
          toOfferId
        } = _ref2;
        return !pauseOffersIDs.includes(toOfferId);
      });
      return !!downgradesFiltered.length;
    }
    return false;
  };
  const shouldShowPauseScreen = () => {
    if (downgrades.length) {
      const pauseOffer = downgrades.filter(_ref3 => {
        let {
          toOfferId
        } = _ref3;
        return pauseOffersIDs.includes(toOfferId);
      });
      return !!pauseOffer.length;
    }
    return false;
  };
  const shouldShowFreeExtension = (retentionActions === null || retentionActions === void 0 ? void 0 : retentionActions.type) === 'FREE_EXTENSION' && !skipAvailableFreeExtensionStep;
  const shouldShowDowngrades = !shouldShowFreeExtension && shouldShowDowngradeScreen();
  const shouldShowPause = shouldShowPauseScreen();
  const [currentStep, setCurrentStep] = (0, _react.useState)(null);
  const pauseOffer = downgradesList === null || downgradesList === void 0 ? void 0 : downgradesList.filter(_ref4 => {
    let {
      toOfferId
    } = _ref4;
    return pauseOffersIDs.includes(toOfferId);
  });
  (0, _react.useEffect)(() => {
    const tempArray = INITIAL_STEPS_ARRAY.slice();
    if (shouldShowDowngrades && !tempArray.includes(_Unsubscribe.default.DOWNGRADES)) {
      tempArray.unshift(_Unsubscribe.default.DOWNGRADES);
    }
    if (shouldShowPause && !tempArray.includes(_Unsubscribe.default.PAUSE)) {
      tempArray.unshift(_Unsubscribe.default.PAUSE);
    }
    if (shouldShowFreeExtension && !tempArray.includes(_Unsubscribe.default.FREE_EXTENSION)) {
      tempArray.unshift(_Unsubscribe.default.FREE_EXTENSION);
    }
    if (tempArray.length !== steps.length) {
      setSteps(tempArray);
    }
    if (!downgradesList.length) setDowngradesList(() => getDowngrades());
  }, []);
  (0, _react.useEffect)(() => {
    setCurrentStep(steps[0]);
  }, [steps]);

  // Filter out the pause subscription
  const downgradesListFiltered = downgradesList === null || downgradesList === void 0 ? void 0 : downgradesList.filter(_ref5 => {
    let {
      toOfferId: offerId
    } = _ref5;
    return !pauseOffersIDs.includes(offerId);
  });
  const isPauseActive = pauseOffersIDs.includes(offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.offerId);
  if (!steps || !currentStep) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  const goToNextStep = () => setCurrentStep(steps[steps.indexOf(currentStep) + 1]);
  const handleUnsubscribe = async () => {
    (0, _eventDispatcher.default)(_eventDispatcher.UNSUBSCRIBE_ACTION_CONFIRMED, {
      detail: {
        offerId: offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.offerId,
        cancellationReason: checkedReason
      }
    });
    await dispatch((0, _unsubscribeSlice.fetchUnsubscribe)({
      offerId: offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.offerId,
      checkedReason,
      isPauseActive
    }));
    setCurrentStep(_Unsubscribe.default.CONFIRMATION);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapper.default, {
    steps: isFreeExtensionSecondStep ? 2 : steps.length,
    popupTitle: t('unsubscribe-popup.title', 'Manage your plan'),
    isError: Boolean(isError),
    currentStep: isFreeExtensionSecondStep ? 2 : steps.indexOf(currentStep) + 1,
    children: [currentStep === _Unsubscribe.default.FREE_EXTENSION && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FreeExtension, {
      handleUnsubscribe: goToNextStep,
      setIsFreeExtensionSecondStep: setIsFreeExtensionSecondStep
    }), currentStep === _Unsubscribe.default.PAUSE && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Pause, {
      pauseOffer: pauseOffer[0],
      handleClick: goToNextStep
    }), currentStep === _Unsubscribe.default.DOWNGRADES && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Downgrades, {
      downgradesListFiltered: downgradesListFiltered,
      handleClick: goToNextStep
    }), currentStep === _Unsubscribe.default.SURVEY && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Survey, {
      customCancellationReasons: customCancellationReasons,
      checkedReason: checkedReason,
      shouldShowDowngrades: shouldShowDowngrades,
      shouldShowFreeExtension: shouldShowFreeExtension,
      handleCheckboxClick: setCheckedReason,
      setCurrentStep: setCurrentStep,
      scheduledSwitch: scheduledSwitch,
      handleUnsubscribe: handleUnsubscribe
    }), currentStep === _Unsubscribe.default.CONFIRMATION && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Confirmation, {})]
  });
};
var _default = exports.default = Unsubscribe;